import type { FunctionComponent } from "react";

interface IconLineProps {
  color?: string;
}

const IconLine: FunctionComponent<IconLineProps> = ({ color = "#000000" }) => {
  return (
    <svg viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.81 0H5.19C2.32364 0 0 2.32364 0 5.19V17.81C0 20.6764 2.32364 23 5.19 23H17.81C20.6764 23 23 20.6764 23 17.81V5.19C23 2.32364 20.6764 0 17.81 0Z"
        fill={color}
      />
      <path
        d="M19.1701 10.42C19.1701 6.98995 15.7301 4.19995 11.5001 4.19995C7.27008 4.19995 3.83008 6.98995 3.83008 10.42C3.83008 13.5 6.56008 16.07 10.2401 16.56C10.4901 16.61 10.8301 16.72 10.9201 16.94C11.0001 17.13 10.9701 17.44 10.9401 17.63C10.9401 17.63 10.8501 18.17 10.8301 18.29C10.8001 18.48 10.6801 19.05 11.4901 18.7C12.3101 18.36 15.9101 16.1 17.5201 14.25C18.6301 13.03 19.1601 11.79 19.1601 10.42H19.1701Z"
        fill="white"
      />
      <path
        d="M16.6193 12.4H14.4693C14.3893 12.4 14.3193 12.33 14.3193 12.25V8.91001C14.3193 8.83001 14.3893 8.76001 14.4693 8.76001H16.6193C16.6993 8.76001 16.7693 8.83001 16.7693 8.91001V9.45001C16.7693 9.53001 16.6993 9.60001 16.6193 9.60001H15.1593V10.16H16.6193C16.6993 10.16 16.7693 10.23 16.7693 10.31V10.85C16.7693 10.93 16.6993 11 16.6193 11H15.1593V11.56H16.6193C16.6993 11.56 16.7693 11.63 16.7693 11.71V12.25C16.7693 12.33 16.6993 12.4 16.6193 12.4Z"
        fill={color}
      />
      <path
        d="M8.64961 12.4C8.72961 12.4 8.79961 12.33 8.79961 12.25V11.71C8.79961 11.63 8.72961 11.56 8.64961 11.56H7.18961V8.9C7.18961 8.82 7.11961 8.75 7.03961 8.75H6.49961C6.41961 8.75 6.34961 8.82 6.34961 8.9V12.24C6.34961 12.32 6.41961 12.39 6.49961 12.39H8.64961V12.4Z"
        fill={color}
      />
      <path
        d="M9.94 8.76001H9.4C9.31716 8.76001 9.25 8.82717 9.25 8.91001V12.25C9.25 12.3329 9.31716 12.4 9.4 12.4H9.94C10.0228 12.4 10.09 12.3329 10.09 12.25V8.91001C10.09 8.82717 10.0228 8.76001 9.94 8.76001Z"
        fill={color}
      />
      <path
        d="M13.6491 8.76H13.1091C13.0291 8.76 12.9591 8.83 12.9591 8.91V10.9L11.4291 8.83V8.81H11.4091V8.79H11.3891V8.77H11.3291V8.75H10.7691C10.6891 8.75 10.6191 8.81 10.6191 8.9V12.25C10.6191 12.33 10.6891 12.4 10.7691 12.4H11.3091C11.3891 12.4 11.4591 12.33 11.4591 12.25V10.26L12.9891 12.33C12.9891 12.33 13.0091 12.36 13.0291 12.37H13.0491V12.39H13.0691C13.0691 12.39 13.0991 12.4 13.1091 12.4H13.6491C13.7291 12.4 13.7991 12.33 13.7991 12.25V8.9C13.7991 8.82 13.7291 8.75 13.6491 8.75V8.76Z"
        fill={color}
      />
    </svg>
  );
};

export default IconLine;
